import { Mail, Phone, MapPin, Facebook, Instagram, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { openCookieBanner } from "@/components/CookieBanner";

const TikTokIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.93a8.16 8.16 0 0 0 4.78 1.52V7a4.85 4.85 0 0 1-1.85-.31z"/>
  </svg>
);

const FB_URL = "https://www.facebook.com/people/Dynastie-Drive-School-Boulogne-Billancourt/";
const IG_URL = "https://www.instagram.com/ddsbillancourt";
const TT_URL = "https://www.tiktok.com/@dds.billancourt";

export default function Footer() {
  return (
    <footer className="bg-[#080C0E] text-white/70" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 text-white font-headings font-black text-xl">
            <img src="/brand/logo.png" alt="DDSBillancourt" className="w-11 h-11 rounded-xl object-contain" />
            DDSBillancourt
          </div>
          <p className="mt-4 text-sm max-w-sm">
            Dynastie Drive School — <strong className="text-white">auto-école à Boulogne-Billancourt</strong>.
            Permis B, moto, poids lourd, code de la route en ligne.
            Formations accélérées. Plateforme e-learning incluse.
          </p>

          <div className="mt-6 flex items-center gap-3">
            <a href={FB_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#00a86b] flex items-center justify-center text-white transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href={IG_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#FF8C42] flex items-center justify-center text-white transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={TT_URL} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tiktok"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-white hover:text-[#080C0E] flex items-center justify-center text-white transition-colors">
              <TikTokIcon className="w-4 h-4" />
            </a>
            <span className="text-xs text-white/50 ml-1">@ddsbillancourt</span>
          </div>
        </div>

        <div>
          <div className="font-headings font-bold text-white mb-4">Formations</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-white" to="/permis-boite-manuelle" data-testid="footer-manuelle">Permis B — boîte manuelle</Link></li>
            <li><Link className="hover:text-white" to="/permis-boite-automatique" data-testid="footer-auto">Permis B — boîte automatique</Link></li>
            <li><Link className="hover:text-white" to="/conduite-accompagnee" data-testid="footer-aac">Conduite accompagnée (AAC)</Link></li>
            <li><Link className="hover:text-white" to="/code-de-la-route" data-testid="footer-code">Code de la route en ligne</Link></li>
            <li><Link className="hover:text-white" to="/moto" data-testid="footer-moto">Permis A / Moto</Link></li>
            <li><a className="hover:text-white" href="#tarifs">Permis AM / BSR</a></li>
            <li><a className="hover:text-white" href="#tarifs">Permis C — poids lourd</a></li>
            <li><a className="hover:text-white" href="#tarifs">Passerelles</a></li>
            <li><Link className="hover:text-white" to="/accelere" data-testid="footer-accelere">Formations accélérées</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-headings font-bold text-white mb-4">Contact & Horaires</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#00a86b] shrink-0" /> 37 Av. Édouard Vaillant<br />92100 Boulogne-Billancourt</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#00a86b] shrink-0" /> 01 41 31 50 61</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#00a86b] shrink-0" /> dynastieblb@gmail.com</li>
            <li className="flex items-start gap-2">
              <Clock className="w-4 h-4 mt-0.5 text-[#00a86b] shrink-0" />
              <span>
                <strong className="text-white block">Conduite</strong>
                Lun. — Sam. · 7h — 22h<br />
                Dimanche · 10h — 20h
              </span>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="w-4 h-4 mt-0.5 text-[#00a86b] shrink-0" />
              <span>
                <strong className="text-white block">Bureau</strong>
                Lun. — Ven. · 10h — 21h<br />
                Samedi · 10h — 18h30
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-6 flex flex-wrap items-center justify-between gap-4 text-xs">
          <div>© {new Date().getFullYear()} DDSBillancourt — Dynastie Drive School. Tous droits réservés.</div>
          <div className="flex gap-5 flex-wrap">
            <Link to="/blog" className="hover:text-white" data-testid="footer-blog">Blog</Link>
            <Link to="/mentions-legales" className="hover:text-white" data-testid="footer-mentions">Mentions légales</Link>
            <Link to="/cgv" className="hover:text-white" data-testid="footer-cgv">CGV</Link>
            <Link to="/confidentialite" className="hover:text-white" data-testid="footer-privacy">Politique de confidentialité</Link>
            <button type="button" onClick={openCookieBanner} className="hover:text-white" data-testid="footer-cookies">Gérer mes cookies</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
